/**
 * "MCP limits & endpoints" — MCP section (ADR-0074).
 * Reconciled from mcp.module.ts (session TTL/cap/rate) and the OAuth endpoints.
 */
import type { DocPageContent } from '../types';

export const MCP_REFERENCE_PAGE: DocPageContent = {
  slug: 'mcp/reference',
  titleKey: 'docs.mcp.reference.title',
  descriptionKey: 'docs.mcp.reference.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.mcp.reference.lead' },

    { kind: 'heading', level: 2, id: 'limits', textKey: 'docs.mcp.reference.limits.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.mcp.reference.limit.ttl',
        'docs.mcp.reference.limit.sessions',
        'docs.mcp.reference.limit.rate',
      ],
    },

    { kind: 'heading', level: 2, id: 'endpoints', textKey: 'docs.mcp.reference.endpoints.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.reference.endpoints.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.mcp.reference.endpoint.metadata',
        'docs.mcp.reference.endpoint.register',
        'docs.mcp.reference.endpoint.authorize',
        'docs.mcp.reference.endpoint.token',
        'docs.mcp.reference.endpoint.mcp',
      ],
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.mcp.reference.next.connect.title',
          textKey: 'docs.mcp.reference.next.connect.text',
          to: { docSlug: 'mcp/connect' },
        },
        {
          titleKey: 'docs.mcp.reference.next.auth.title',
          textKey: 'docs.mcp.reference.next.auth.text',
          to: { docSlug: 'mcp/authentication' },
        },
      ],
    },
  ],
};
